import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { setTableColumnWidths } from "../../actions/tableSortingActions";
import ManualVersioningTable from "./ManualVersioningTable";
import AutoVersioningTable from "./AutoVersioningTable";

export const MANUAL_TABLE_ID = "/documentProperties/versionsExpandable";
export const AUTO_TABLE_ID = "/documentProperties/versions";

function DocumentVersions({
	firmHasManualVersioningEnabled,
	documentManualVersioningData,
	userOverriddenSort,
	persistColumnWidths,
	...rest
}) {
	const useExpandable =
		firmHasManualVersioningEnabled ||
		documentManualVersioningData?.counter != null;

	return useExpandable ? (
		<ManualVersioningTable
			tableUniqueID={MANUAL_TABLE_ID}
			documentManualVersioningData={documentManualVersioningData}
			userOverriddenSort={userOverriddenSort}
			persistColumnWidths={persistColumnWidths}
			{...rest}
		/>
	) : (
		<AutoVersioningTable tableUniqueID={AUTO_TABLE_ID} {...rest} />
	);
}

DocumentVersions.propTypes = {
	firmHasManualVersioningEnabled: PropTypes.bool,
	documentManualVersioningData: PropTypes.shape({
		counter: PropTypes.number,
		labels: PropTypes.array,
	}),
	userOverriddenSort: PropTypes.object,
	persistColumnWidths: PropTypes.func,
};

export default connect(
	(state) => ({
		userOverriddenSort: state.tableSorting[MANUAL_TABLE_ID],
	}),
	{ persistColumnWidths: setTableColumnWidths }
)(DocumentVersions);
